module.exports = __webpack_public_path__ + "static/media/ProjectStep5.0c604a15.png";